import {
	// FETCH_NI_SMELTER_PRODUCTION_INIT,
	FETCH_NI_SMELTER_PRODUCTION,
	RESET_NI_SMELTER_PRODUCTION
} from '../../actions';

// const INITIAL_STATE = {
// 	timestamp: ''
// 	// data: ''
// };

// //response is valid if request timestamp is fresher
// function isResponseValid(t1, t2) {
// 	return t2 >= t1;
// }

// export default (state = INITIAL_STATE, action) => {
// 	switch (action.type) {
// 		case FETCH_NI_SMELTER_PRODUCTION_INIT:
// 			return {
// 				...state,
// 				...action.payload
// 			};
// 		case FETCH_NI_SMELTER_PRODUCTION: {
// 			// const { data, timestamp } = action.payload;
// 			const { timestamp, ...data } = action.payload;
// 			if (isResponseValid(state.timestamp, timestamp)) {
// 				return {
// 					...state,
// 					...data
// 				};
// 			}
// 			console.log('state', state);
// 			return state;
// 		}
// 		case RESET_NI_SMELTER_PRODUCTION: {
// 			return INITIAL_STATE;
// 		}
// 		default:
// 			return state;
// 	}
// };
export default (state = {}, action) => {
	switch (action.type) {
		case FETCH_NI_SMELTER_PRODUCTION:
			// console.log('payload', action.payload);
			return { ...state, ...action.payload };
		case RESET_NI_SMELTER_PRODUCTION:
			return {};
		default:
			return state;
	}
};
